import React from 'react';
import { Outlet } from 'react-router-dom';
import PublicNav from './PublicNav';
import Footer from './Footer';

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-white text-slate-900 antialiased">
      <PublicNav />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
